import { DeploymentClient } from 'utilities/db';
import { useQuery } from 'react-query';

export const useFetchCustomDomainStatusHook = (
  keyName,
  brandId,
  brandName,
  enviorment
) => {
  const { status, data, error, isFetching, isLoading, refetch } = useQuery(
    [keyName, brandId, brandName, enviorment],
    () => getData(brandId, brandName, enviorment),
    {
      enabled: !!brandId && !!brandName && !!enviorment,
      refetchInterval: 30000
    }
  );

  return {
    customDomainStatus: status,
    customDomainData: data,
    customDomainError: error,
    customDomainFetching: isFetching,
    customDomainLoading: isLoading,
    customDomainRefetch: refetch
  };
};

const getData = async (brandId, brandName, enviorment) => {
  let result = await DeploymentClient.post(
    `/deployment/checkCustomDomainStatus`,
    {
      brandId: `${brandId}`,
      brandName,
      enviorment
    }
  );
  result = result.data;
  return result;
};
